<template>
  <div>
    <!-- BUTTON SELECTION -->
    <div v-if="data.tag !== undefined && data.tag !== null">
      <div v-if="btnSpin == false">
        <v-btn icon v-if="data.btn == 'icon'" :color="ui.bkgdColor"
        @click="getDocumentInfoCardData()">
          <v-icon :color="ui.btnColor">
            {{this.defineDocumentFromTag(this.data.tag).icon}}
          </v-icon>
        </v-btn>
        <v-btn flat v-if="data.btn == 'flat'" :color="ui.btnColor"
        @click="getDocumentInfoCardData()">
          <v-icon left>
            {{this.defineDocumentFromTag(this.data.tag).icon}}
          </v-icon>
            {{this.defineDocumentFromTag(this.data.tag).title}}
        </v-btn>
      </div>
      <div v-else>
        <BtnSpin v-if="data.size == 'icon'" :btnSpec="btnInfo1"/>
        <BtnSpin v-if="data.size == 'flat'" :btnSpec="btnInfo2"/>
      </div>
    </div>
    <v-dialog v-model="dialog" persistent :max-width="ui.sizeWidthDialogLarge">
      <v-card :color="ui.cardColor">
        <v-card-title>
          <v-icon large left :color="ui.iconColor">
            {{this.defineDocumentFromTag(this.localForm.tag).icon}}
          </v-icon>
          <span :class="ui.textTitle">
            {{this.defineDocumentFromTag(this.localForm.tag).title}}
          </span>
          <v-spacer/>
          <span :class="ui.textTitle">
            {{displayDocumentIDGTypeA(this.localForm.tag, this.localForm.idg)}}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container :class="ui.bkgdColor">
            <v-layout row>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> title </v-icon>
                </v-avatar>
                {{localForm.title}}
              </v-chip>
              <v-spacer/>
            </v-layout>
            <v-layout row v-if="this.localForm.tag !== 'U1'">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> sell </v-icon>
                </v-avatar>
                {{localForm.id}}
              </v-chip>
              <v-spacer/>
            </v-layout>
            <div v-if="this.data.tag === 'B1'" class="mt-4 mb-4">
              <v-layout row>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> adjust </v-icon>
                  </v-avatar>
                  Risk Impacts
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> update </v-icon>
                  </v-avatar>
                  {{localForm.time}}
                </v-chip>
              </v-layout>
              <v-layout row justify-end wrap>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> health_and_safety </v-icon>
                  </v-avatar>
                  {{localForm.ihse}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> paid </v-icon>
                  </v-avatar>
                  {{localForm.ifin}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> eco </v-icon>
                  </v-avatar>
                  {{localForm.ienv}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> work_outline </v-icon>
                  </v-avatar>
                  {{localForm.ibus}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> groups </v-icon>
                  </v-avatar>
                  {{localForm.isoc}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> star_half </v-icon>
                  </v-avatar>
                  {{localForm.irep}}
                </v-chip>
              </v-layout>
              <v-layout row>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> bubble_chart </v-icon>
                  </v-avatar>
                  Risk Rating
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> bar_chart </v-icon>
                  </v-avatar>
                  {{localForm.rate}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> medication </v-icon>
                  </v-avatar>
                  {{localForm.rec}}
                </v-chip>
              </v-layout>
              <v-layout row justify-end wrap>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> date_range </v-icon>
                  </v-avatar>
                  {{localForm.long}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> trip_origin </v-icon>
                  </v-avatar>
                  {{localForm.system}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> error_outline </v-icon>
                  </v-avatar>
                  {{localForm.outcome}}
                </v-chip>
              </v-layout>
            </div>
            <div v-if="this.data.tag === 'L1'" class="mt-4 mb-4">
              <v-layout row>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> map </v-icon>
                  </v-avatar>
                  Technical Order
                </v-chip>
              </v-layout>
              <v-layout row justify-end wrap>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> warehouse </v-icon>
                  </v-avatar>
                  {{localForm.make}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> emoji_symbols </v-icon>
                  </v-avatar>
                  {{localForm.model}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> receipt_long </v-icon>
                  </v-avatar>
                  {{localForm.cert}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> timelapse </v-icon>
                  </v-avatar>
                  {{localForm.lead}}
                </v-chip>
              </v-layout>
              <v-layout row>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> build_circle </v-icon>
                  </v-avatar>
                  Install and Repair
                </v-chip>
              </v-layout>
              <v-layout row justify-end wrap>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> hourglass_empty </v-icon>
                  </v-avatar>
                  {{localForm.avail}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> shopping_cart </v-icon>
                  </v-avatar>
                  {{localForm.supp}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> upgrade </v-icon>
                  </v-avatar>
                  {{localForm.rep}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> plumbing </v-icon>
                  </v-avatar>
                  {{localForm.eng}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> build </v-icon>
                  </v-avatar>
                  {{localForm.repair}}
                </v-chip>
                <!-- <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> recycling </v-icon>
                  </v-avatar>
                  {{localForm.rec}}
                </v-chip> -->
              </v-layout>
            </div>
            <div v-if="this.data.tag === 'A1'" class="mt-4 mb-4">
              <v-layout row>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> map </v-icon>
                  </v-avatar>
                  Access and Location
                </v-chip>
              </v-layout>
              <v-layout row justify-end wrap>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> schema </v-icon>
                  </v-avatar>
                  {{localForm.sys}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> data_usage </v-icon>
                  </v-avatar>
                  {{localForm.unit}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> grid_on </v-icon>
                  </v-avatar>
                  {{localForm.grid}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> login </v-icon>
                  </v-avatar>
                  {{localForm.accl}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> view_day </v-icon>
                  </v-avatar>
                  {{localForm.acct}}
                </v-chip>
              </v-layout>
              <v-layout row>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> build_circle </v-icon>
                  </v-avatar>
                  Maintenance and Isolations
                </v-chip>
              </v-layout>
              <v-layout row justify-end wrap>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> toggle_on </v-icon>
                  </v-avatar>
                  {{localForm.mode}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> build </v-icon>
                  </v-avatar>
                  {{localForm.str}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> lock_clock </v-icon>
                  </v-avatar>
                  {{localForm.isol}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> lock </v-icon>
                  </v-avatar>
                  {{localForm.isot}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> key </v-icon>
                  </v-avatar>
                  {{localForm.keym}}
                </v-chip>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> enhanced_encryption </v-icon>
                  </v-avatar>
                  {{localForm.isok}}
                </v-chip>
              </v-layout>
            </div>
            <v-layout row v-if="this.data.tag !== 'A1' && this.data.tag !== 'L1'">
              <span :class="ui.textSubheading" v-if="info.trans">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                  <v-avatar>
                    <v-icon>{{localForm.transIcon}}</v-icon>
                  </v-avatar>
                  {{localForm.transStatus}}
                </v-chip>
              </span>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold"
              v-if="this.info.dateType === 'TypeA'"
              >
                <v-avatar>
                  <v-icon>{{info.dateIcon}}</v-icon>
                </v-avatar>
                {{dateTypeA(info.dateData)}}
              </v-chip>
            </v-layout>
            <v-layout row>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>{{info.infoIcon1}}</v-icon>
                </v-avatar>
                {{info.infoTitle1}}
              </v-chip>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>{{info.infoIcon2}}</v-icon>
                </v-avatar>
                {{info.infoTitle2}}
              </v-chip>
            </v-layout>
            <v-layout>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                <v-avatar>
                <v-icon> short_text </v-icon>
                </v-avatar>
                Description
              </v-chip>
              <v-spacer/>
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>{{info.infoIcon3}}</v-icon>
                </v-avatar>
                {{info.infoTitle3}}
              </v-chip>
            </v-layout>
            <v-layout class="ml-3 mr-3 mt-1">
              <v-flex xs11 offset-xs1>
                <div :class="ui.textSubheadingGrey">
                  {{info.description}}
                </div>
              </v-flex>
            </v-layout>
            <div v-if="this.data.tag === 'S1'">
              <v-layout class="mt-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> shield </v-icon>
                  </v-avatar>
                  Risk Controls
                </v-chip>
                <v-spacer/>
              </v-layout>
              <v-layout class="ml-3 mr-3 mt-1">
                <v-flex xs11 offset-xs1>
                  <div :class="ui.textSubheadingGrey">
                    {{info.contc}}
                  </div>
                </v-flex>
              </v-layout>
            </div>
            <v-layout class="mt-4 mr-3">
              <v-spacer/>
              <DocumentStatus :data="{
                model: 'SMALL',
                rev: this.displayDocumentRevTypeA(this.rev),
                sec: localForm.revsec,
                stat: localForm.revstat,
                type: localForm.revtype}
                "/>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="closeDialog()" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
          <v-spacer/>
          <GetDetailPage
          v-if="
          this.enableFacilityDocument === true &&
          this.localForm.tag !== 'E6' &&
          this.localForm.tag !== 'W1' &&
          this.localForm.tag !== 'W2'
          "
          :data="{
            tag: 'LINK',
            stag: this.localForm.tag,
            sdid: this.localForm.did,
            size: 'flat',
            item: null}"
          />
          <GetDetailPage
          v-if="
          this.getDetailLink !== null &&
          this.getDetailLink !== undefined &&
          this.getDetailLink.sdid !== undefined &&
          this.enableSource === true &&
          this.info.link === true
          "
          :data="{
            tag: 'LINK',
            stag: this.data.tag,
            sdid: this.data.did,
            size: 'flat',
            item: this.getDetailLink}"
          />
          <GetDetailPage
          v-if="enableChild &&
          this.info.link === true &&
          this.localForm.tag !== 'B3' && this.localForm.tag !== 'L1'"
          :data="{
            tag: 'LINK',
            stag: this.data.tag,
            sdid: this.data.did,
            size: 'flat',
            item: this.getDetailLink,
            page: null}"
          />
          <GetDetailPage v-if="enableWorkTool && this.info.link === true"
          :data="{
            tag: 'LINK',
            stag: this.data.tag,
            sdid: this.data.did,
            size: 'flat',
            item: this.getDetailLink,
            page: '/worktooldetail'}"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import getData from "@/data/cloud/firebase/mixins/getData.js";
import DocumentStatus from "@/document/revisions/components/DocumentStatus";
import describeDocument from "@/data/describe/mixins/describeDocument";
import revFunctions from "@/data/functions/mixins/revFunctions.js";
import GetDetailPage from "@/support/detail/components/GetDetailPage";
import revs from "@/data/forms/mixins/revs.js";
import { mapGetters } from "vuex";
export default {
  props: {
    data: {
      type: Object
    }
  },
  components: {
    BtnSpin,
    DocumentStatus,
    GetDetailPage
  },
  watch: {
    dataSaved() {
      if (this.ctr === 1) {
        this.ctr = this.ctr + 1;
        this.dialog = true;
      }
    }
  },
  // eslint-disable-next-line
  mixins: [
    apptheme,
    numberFunctions,
    getData,
    dateFunctions,
    displayFunctions,
    describeDocument,
    displayFunctions,
    revFunctions,
    revs
  ],
  data() {
    return {
      valid: true,
      dialog: false,
      ctr: 0, // this prevent bounce that lead to overstack limt
      btnSpin: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: "icon"
      },
      btnInfo2: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: ""
      },
      localForm: {
        id: "Undefined ID",
        idg: "Undefined IDG",
        did: "",
        title: "Undefined Title",
        tag: "B1", // intial to allow functions to load
        cond: "",
        dcrt: "",
        dstr: "",
        drev: "",
        ddue: "",
        devent: "",
        des: "",
        dis: "",
        lead: "",
        scope: "",
        reach: "",
        make: "",
        type: "",
        theme: "",
        revsec: "",
        revstat: "",
        revtype: "",
        isok: "",
        isol: "",
        isot: "",
        keym: "",
        mode: "",
        str: "",
        sys: "",
        unit: "",
        grid: "",
        accl: "",
        acct: "",
        ibus: "",
        ienv: "",
        ifin: "",
        ihse: "",
        irep: "",
        isoc: "",
        time: "",
        long: "",
        rec: "",
        system: "",
        rate: "",
        outcome: "",
        cat: "",
        model: "",
        carbe: "",
        carrbu: "",
        coste: "",
        costu: "",
        cert: "",
        avail: "",
        supp: "",
        rep: "",
        eng: "",
        repair: "",
        recycle: "",
        contc: ""
      },
      rev: {}
    };
  },
  created() {
    this.rev = this.formDocumentRevision;
  },
  updated() {
    // fix orginal data before change
    if (this.getInfoCard !== null) {
      // BASIC
      this.localForm.id = this.getInfoCard.basic.id;
      this.localForm.idg = this.getInfoCard.basic.idg;
      this.localForm.tag = this.getInfoCard.basic.tag;
      this.localForm.did = this.getInfoCard.basic.did;
      this.localForm.title = this.getInfoCard.basic.title;
      // CHAR
      this.localForm.des = this.getInfoCard.char.des;
      this.localForm.dis = this.getInfoCard.char.dis;
      this.localForm.dis = this.getInfoCard.char.dis;
      this.localForm.cat = this.getInfoCard.char.cat;
      this.localForm.obj = this.getInfoCard.char.obj;
      this.localForm.cond = this.getInfoCard.char.cond;
      this.localForm.driver = this.getInfoCard.char.driver;
      this.localForm.lead = this.getInfoCard.char.lead;
      this.localForm.scope = this.getInfoCard.char.scope;
      this.localForm.type = this.getInfoCard.char.type;
      this.localForm.theme = this.getInfoCard.char.theme;
      this.localForm.reach = this.getInfoCard.char.reach;
      this.localForm.cond = this.getInfoCard.char.cond;
      this.localForm.make = this.getInfoCard.char.make;
      this.localForm.pri = this.getInfoCard.char.pri;
      this.localForm.isok = this.getInfoCard.char.isok;
      this.localForm.isol = this.getInfoCard.char.isol;
      this.localForm.isot = this.getInfoCard.char.isot;
      this.localForm.keym = this.getInfoCard.char.keym;
      this.localForm.mode = this.getInfoCard.char.mode;
      this.localForm.str = this.getInfoCard.char.str;
      this.localForm.sys = this.getInfoCard.char.sys;
      this.localForm.unit = this.getInfoCard.char.unit;
      this.localForm.grid = this.getInfoCard.char.grid;
      this.localForm.accl = this.getInfoCard.char.accl;
      this.localForm.acct = this.getInfoCard.char.acct;
      this.localForm.time = this.getInfoCard.char.time;
      this.localForm.ibus = this.getInfoCard.char.ibus;
      this.localForm.ienv = this.getInfoCard.char.ienv;
      this.localForm.ifin = this.getInfoCard.char.ifin;
      this.localForm.ihse = this.getInfoCard.char.ihse;
      this.localForm.irep = this.getInfoCard.char.irep;
      this.localForm.isoc = this.getInfoCard.char.isoc;
      this.localForm.long = this.getInfoCard.char.long;
      this.localForm.rec = this.getInfoCard.char.rec;
      this.localForm.system = this.getInfoCard.char.system;
      this.localForm.rate = this.getInfoCard.char.rate;
      this.localForm.outcome = this.getInfoCard.char.outcome;
      this.localForm.model = this.getInfoCard.char.model;
      this.localForm.carbe = this.getInfoCard.char.carbe;
      this.localForm.carbu = this.getInfoCard.char.carbu;
      this.localForm.coste = this.getInfoCard.char.coste;
      this.localForm.costu = this.getInfoCard.char.costu;
      this.localForm.cert = this.getInfoCard.char.cert;
      this.localForm.avail = this.getInfoCard.char.avail;
      this.localForm.supp = this.getInfoCard.char.supp;
      this.localForm.rep = this.getInfoCard.char.rep;
      this.localForm.eng = this.getInfoCard.char.eng;
      this.localForm.repair = this.getInfoCard.char.repair;
      this.localForm.rec = this.getInfoCard.char.recyle;
      this.localForm.contc = this.getInfoCard.char.contc;

      // STATS
      this.localForm.dcrt = this.getInfoCard.stats.dcrt;
      this.localForm.dcall = this.getInfoCard.stats.dcall;
      this.localForm.drev = this.getInfoCard.stats.drev;
      this.localForm.ddue = this.getInfoCard.stats.ddue;
      this.localForm.dstr = this.getInfoCard.stats.dstr;
      this.localForm.devent = this.getInfoCard.stats.devent;
      // REV
      this.rev = this.getInfoCard.rev;
      this.localForm.revsec = this.getInfoCard.rev.sec;
      this.localForm.revstat = this.getInfoCard.rev.stat;
      this.localForm.revtype = this.getInfoCard.rev.type;
      if (
        this.data.tag !== "A1" &&
        this.data.tag !== "E1" &&
        this.data.tag !== "E6" &&
        this.data.tag !== "E8" &&
        this.data.tag !== "L1" &&
        this.data.tag !== "S1"
      ) {
        let flow = this.getInfoCard.trans.flow;
        // TRANS
        this.localForm.transIcon = flow[flow.length - 1].icon;
        this.localForm.transStatus = flow[flow.length - 1].title;
      }
    }
  },
  computed: {
    ...mapGetters(["getInfoCard", "getUser", "getDataLink", "getRegisterInfo"]),
    enableSource() {
      let logic = null;
      let usercdid = this.getUser.pref.select.cdid;
      let userfdid = this.getUser.pref.select.fdid;
      if (usercdid !== "") {
        if (this.localForm.tag === "L1") {
          logic = true;
        } else {
          logic = false;
        }
      } else if (this.getDetailLink.cdid === usercdid && userfdid === "") {
        logic = true;
      } else if (
        this.getDetailLink.cdid === usercdid &&
        this.getDetailLink.fdid !== "" &&
        this.getDetailLink.fdid === userfdid
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableFacilityDocument() {
      let logic = false;
      let tag = this.localForm.tag;
      let usercdid = this.getUser.pref.select.cdid;
      let userfdid = this.getUser.pref.select.fdid;
      if (
        tag !== null &&
        tag !== "A1" &&
        tag !== "S1" &&
        usercdid !== null &&
        usercdid !== undefined &&
        usercdid !== "" &&
        userfdid !== null &&
        userfdid !== undefined &&
        userfdid !== ""
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableWorkTool() {
      let logic = null;
      // ASSUMPTION we are at SAME COMPANY
      if (this.getDetailBasic !== null && this.getDetailBasic.tag === "B3") {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableChild() {
      let logic = null;
      let usercdid = this.getUser.pref.select.cdid;
      let userfdid = this.getUser.pref.select.fdid;
      // ASSUMPTION we are at SAME COMPANY
      if (this.data.fdid === "" && usercdid !== "" && usercdid !== undefined) {
        logic = true;
      } else if (this.data.fdid === userfdid) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    dataSaved() {
      let saved = false;
      if (this.getInfoCard !== null && this.ctr === 1) {
        saved = true;
        // this.ctr = this.ctr + 1;
      } else {
        saved = false;
      }
      return saved;
    },
    info() {
      let obj = {
        trans: false,
        link: true,
        dateData: "",
        dateType: "",
        dateIcon: "",
        infoIcon1: "",
        infoTitle1: "",
        infoIcon2: "",
        infoTitle2: "",
        infoIcon3: "",
        infoTitle3: "",
        description: ""
      };
      if (this.data.tag === "A1") {
        // ASSET
        obj.trans = false;
        obj.dateData = this.localForm.dedit;
        obj.dateIcon = "event";
        obj.dateType = "TypeA";
        obj.infoIcon1 = "factory";
        obj.infoTitle1 = this.localForm.type;
        obj.infoIcon2 = "adjust";
        obj.infoTitle2 = this.localForm.obj;
        obj.infoIcon3 = "engineering";
        obj.infoTitle3 = this.localForm.dis;
        obj.description = this.localForm.des;
      }
      if (this.data.tag === "B1") {
        // RISK
        obj.trans = true;
        obj.dateData = this.localForm.drev;
        obj.dateIcon = "event";
        obj.dateType = "TypeA";
        obj.infoIcon1 = "grid_view";
        obj.infoTitle1 = this.localForm.type;
        obj.infoIcon2 = "work_outline";
        obj.infoTitle2 = this.localForm.theme;
        obj.infoIcon3 = "engineering";
        obj.infoTitle3 = this.localForm.dis;
        obj.description = this.localForm.des;
      }
      if (this.data.tag === "B3") {
        // ACTION
        obj.trans = true;
        obj.dateData = this.localForm.ddue;
        obj.dateIcon = "event";
        obj.dateType = "TypeA";
        obj.infoIcon1 = "grid_view";
        obj.infoTitle1 = this.localForm.type;
        obj.infoIcon2 = "work_outline";
        obj.infoTitle2 = this.localForm.theme;
        obj.infoIcon3 = "engineering";
        obj.infoTitle3 = this.localForm.dis;
        obj.description = this.localForm.scope;
      }
      if (this.data.tag === "B4") {
        // ACTION
        obj.trans = true;
        obj.dateData = this.localForm.dstr;
        obj.dateIcon = "edit_calendar";
        obj.dateType = "TypeA";
        obj.infoIcon1 = "grid_view";
        obj.infoTitle1 = this.localForm.type;
        obj.infoIcon2 = "work_outline";
        obj.infoTitle2 = this.localForm.theme;
        obj.infoIcon3 = "engineering";
        obj.infoTitle3 = this.localForm.dis;
        obj.description = this.localForm.des;
      }
      if (this.data.tag === "B6") {
        // ACTION
        obj.trans = true;
        obj.dateData = this.localForm.dstr;
        obj.dateIcon = "edit_calendar";
        obj.dateType = "TypeA";
        obj.infoIcon1 = "grid_view";
        obj.infoTitle1 = this.localForm.type;
        obj.infoIcon2 = "work_outline";
        obj.infoTitle2 = this.localForm.theme;
        obj.infoIcon3 = "engineering";
        obj.infoTitle3 = this.localForm.dis;
        obj.description = this.localForm.des;
      }
      if (this.data.tag === "E1") {
        // EQUIP
        obj.trans = false;
        obj.dateData = this.localForm.drev;
        obj.dateIcon = "event";
        obj.dateType = "TypeA";
        obj.infoIcon1 = "grid_view";
        obj.infoTitle1 = this.localForm.type;
        obj.infoIcon2 = "time_to_leave";
        obj.infoTitle2 = this.localForm.cat;
        obj.infoIcon3 = "engineering";
        obj.infoTitle3 = this.localForm.dis;
        obj.description = this.localForm.des;
      }
      if (this.data.tag === "E6") {
        // HAZARD
        obj.trans = false;
        obj.dateData = this.localForm.dcrt;
        obj.dateIcon = "event";
        obj.dateType = "TypeA";
        obj.infoIcon1 = "grid_view";
        obj.infoTitle1 = this.localForm.type;
        obj.infoIcon2 = "low_priority";
        obj.infoTitle2 = this.localForm.cond;
        obj.infoIcon3 = "engineering";
        obj.infoTitle3 = this.localForm.dis;
        obj.description = this.localForm.des;
      }
      if (this.data.tag === "L1") {
        // MATERIAL
        obj.trans = false;
        obj.dateData = this.localForm.drev;
        obj.dateIcon = "edit_calendar";
        obj.dateType = "TypeA";
        obj.infoIcon1 = "paid";
        obj.infoTitle1 = this.localForm.coste + this.localForm.costu;
        obj.infoIcon2 = "co2";
        obj.infoTitle2 = this.localForm.carbe + this.localForm.carbu;
        obj.infoIcon3 = "engineering";
        obj.infoTitle3 = this.localForm.dis;
        obj.description = this.localForm.des;
      }
      if (this.data.tag === "M2") {
        // MATERIAL
        obj.trans = false;
        obj.link = false;
        obj.dateData = this.localForm.drev;
        obj.dateIcon = "edit_calendar";
        obj.dateType = "TypeA";
        obj.infoIcon1 = "grid_view";
        obj.infoTitle1 = this.localForm.type;
        obj.infoIcon2 = "water_drop";
        obj.infoTitle2 = this.localForm.driver;
        obj.infoIcon3 = "engineering";
        obj.infoTitle3 = this.localForm.dis;
        obj.description = this.localForm.des;
      }
      if (this.data.tag === "M5") {
        // MATERIAL
        obj.trans = true;
        obj.link = false;
        obj.dateData = this.localForm.dcall;
        obj.dateIcon = "edit_calendar";
        obj.dateType = "TypeA";
        obj.infoIcon1 = "grid_view";
        obj.infoTitle1 = this.localForm.type;
        obj.infoIcon2 = "yard";
        obj.infoTitle2 = this.localForm.theme;
        obj.infoIcon3 = "priority_high";
        obj.infoTitle3 = this.localForm.pri;
        obj.description = this.localForm.scope;
      }
      if (this.data.tag === "M7") {
        // MATERIAL
        obj.trans = true;
        obj.dateData = this.localForm.drev;
        obj.dateIcon = "edit_calendar";
        obj.dateType = "TypeA";
        obj.infoIcon1 = "grid_view";
        obj.infoTitle1 = this.localForm.type;
        obj.infoIcon2 = "water_drop";
        obj.infoTitle2 = this.localForm.driver;
        obj.infoIcon3 = "engineering";
        obj.infoTitle3 = this.localForm.dis;
        obj.description = this.localForm.des;
      }
      if (this.data.tag === "S1") {
        // HAZARD
        obj.trans = true;
        obj.dateData = this.localForm.drev;
        obj.dateIcon = "event";
        obj.dateType = "TypeA";
        obj.infoIcon1 = "filter_list";
        obj.infoTitle1 = this.localForm.reach;
        obj.infoIcon2 = "adjust";
        obj.infoTitle2 = this.localForm.cond;
        obj.infoIcon3 = "error_outline";
        obj.infoTitle3 = this.localForm.theme;
        obj.description = this.localForm.des;
        obj.contc = this.localForm.contc;
      }
      if (this.data.tag === "S6") {
        // HAZARD
        obj.trans = true;
        obj.dateData = this.localForm.devent;
        obj.dateIcon = "event";
        obj.dateType = "TypeA";
        obj.infoIcon1 = "filter_list";
        obj.infoTitle1 = this.localForm.reach;
        obj.infoIcon2 = "adjust";
        obj.infoTitle2 = this.localForm.cond;
        obj.infoIcon3 = "work_outline";
        obj.infoTitle3 = this.localForm.theme;
        obj.description = this.localForm.des;
      }
      if (this.data.tag === "W1" || this.data.tag === "W2") {
        // HAZARD
        obj.trans = true;
        obj.dateData = this.localForm.dcrt;
        obj.dateIcon = "event";
        obj.dateType = "TypeA";
        obj.infoIcon1 = "water_drop";
        obj.infoTitle1 = this.localForm.driver + " - " + this.localForm.pri;
        obj.infoIcon2 = "settings_suggest";
        obj.infoTitle2 = this.localForm.theme;
        obj.infoIcon3 = "grid_view";
        obj.infoTitle3 = this.localForm.type + " - " + this.localForm.dis;
        obj.description = this.localForm.des;
      }
      if (this.data.tag === "W6") {
        // HAZARD
        obj.trans = false;
        obj.dateData = this.localForm.dcrt;
        obj.dateIcon = "event";
        obj.dateType = "TypeA";
        obj.infoIcon1 = "grid_view";
        obj.infoTitle1 = this.localForm.type;
        obj.infoIcon2 = "apps_outage";
        obj.infoTitle2 = this.localForm.cat;
        obj.infoIcon3 = "engineering";
        obj.infoTitle3 = this.localForm.dis;
        obj.description = this.localForm.des;
      }
      return obj;
    }
  },
  methods: {
    closeDialog() {
      // reset store
      // this.$store.dispatch("changeCompany", null);
      this.btnSpin = false;
      this.dialog = false;
      this.ctr = 0;
      this.$store.dispatch("changeInfoCard", null);
    },
    getDocumentInfoCardData() {
      if (this.ctr === 0) {
        this.ctr = this.ctr + 1;
        this.btnSpin = true;
        this.getDocumentInfoCard(this.data.tag, this.data.did);
      }
    }
  }
};
</script>
